module.exports = __webpack_public_path__ + "research.svg?4e19ba5486e7a976910b5e0eed1244f9";